//Add Backend Notification Types here.
export var HLServiceEventType;
(function (HLServiceEventType) {
    HLServiceEventType["CollectionDeployReady"] = "CollectionDeployReady";
    HLServiceEventType["CollectionDeployFailed"] = "CollectionDeployFailed";
})(HLServiceEventType || (HLServiceEventType = {}));
//All Frontend specific notification types go here
export var CreateCollectionEvents;
(function (CreateCollectionEvents) {
    CreateCollectionEvents["CreateCollectionUpdate"] = "CreateCollectionUpdate";
})(CreateCollectionEvents || (CreateCollectionEvents = {}));
//Map Backend Notification to Frontend Notification
export const WebsocketEventMapping = {
    [HLServiceEventType.CollectionDeployReady]: CreateCollectionEvents.CreateCollectionUpdate,
    [HLServiceEventType.CollectionDeployFailed]: CreateCollectionEvents.CreateCollectionUpdate,
};
